/* eslint-disable class-methods-use-this */
import { getters, state } from '@/store/index';
import ToastService from '@/modules/toasts/services/ToastService';
import WCSimpleToast from '@/modules/toasts/components/WCSimpleToast/WCSimpleToast.vue';

class RecaptchaService {
  constructor() {
    this.loaded = false;
    this.key = '';
  }

  configure() {
    this.key = getters.getRecaptchaKey(state);
  }

  isEnabled() {
    return !!this.key;
  }

  showBlockedAlert() {
    ToastService.open(WCSimpleToast, {
      props: {
        variant: 'warning',
        title: 'Security Verification Unavailable',
        message:
          'Security verification is currently unavailable. ' +
          'Some features may not work properly. Please check your browser settings or ad blocker.',
      },
      timeout: 0,
    });
  }

  load() {
    if (!this.loaded) {
      this.loaded = new Promise((resolve, reject) => {
        if (!this.key) {
          reject(new Error('No Recaptcha key'));
        }

        window.grecaptchaReadyCallback = () => {
          resolve();
        };

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.key}`;
        script.onerror = () => {
          const error = new Error('Failed to load reCAPTCHA script');
          this.showBlockedAlert();
          reject(error);
        };
        script.onload = () => {
          if (window.grecaptcha?.enterprise?.ready) {
            window.grecaptcha.enterprise.ready(() => {
              window.grecaptchaReadyCallback();
            });
          } else {
            this.showBlockedAlert();
            reject(new Error('reCAPTCHA not available'));
          }
        };
        document.body.appendChild(script);
      });
    }

    return this.loaded;
  }

  async execute(action) {
    if (!this.isEnabled()) {
      return Promise.resolve('');
    }

    try {
      this.load();
      return await window.grecaptcha.enterprise.execute(this.key, { action });
    } catch (error) {
      console.error('reCAPTCHA execute error:', error);
      return '';
    }
  }
}

export default new RecaptchaService();
